function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D03",
  d: "M3.32 53.976C.19 47.918-.797 40.92.66 33.962c2.482-11.866 12.233-21.185 24.195-23.148 20.393-3.348 37.85 14.112 34.505 34.505-1.963 11.962-11.284 21.713-23.148 24.196-6.96 1.456-13.958.469-20.015-2.661l-8.323 1.998c-3.945.947-7.5-2.607-6.554-6.552l2-8.324",
  opacity: 0.2,
  transform: "translate(-157 -196) translate(0 96) translate(157 102)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.642 18C17.136 18 7 28.136 7 40.642c0 4.642 1.402 8.955 3.798 12.547l-1.987 8.283 8.283-1.99c3.592 2.397 7.905 3.801 12.548 3.801 12.505 0 22.641-10.138 22.641-22.641C52.283 28.136 42.147 18 29.642 18z",
  transform: "translate(-157 -196) translate(0 96) translate(157 102)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8D03",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3.623,
  d: "M29.642 18C17.136 18 7 28.136 7 40.642c0 4.642 1.402 8.955 3.798 12.547l-1.987 8.283 8.283-1.99c3.592 2.397 7.905 3.801 12.548 3.801 12.505 0 22.641-10.138 22.641-22.641C52.283 28.136 42.147 18 29.642 18zM63.56 9.2l-6.654 6.653m13.21 37.163l-5.588-1.498m9.088 2.436l-9.088-2.436m-8.218 17.89l-2.047-2.045m16.82-36.196l-5.588 1.497M42.56 0L41.06 5.588",
  transform: "translate(-157 -196) translate(0 96) translate(157 102)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D03",
  fillRule: "nonzero",
  stroke: "#FF8C03",
  d: "M37.144 48.32h-1.671c.122-.72.122-1.62-.245-2.68-.59-1.78-2.017-3.5-4.26-5.14 2.222-1.64 3.649-3.36 4.26-5.14.347-1.06.367-1.96.245-2.68h1.671c.469 0 .856-.38.856-.84 0-.46-.387-.84-.856-.84H21.856c-.469 0-.856.38-.856.84 0 .46.387.84.856.84h1.671c-.122.72-.122 1.62.245 2.68.59 1.78 2.017 3.5 4.26 5.14-2.222 1.64-3.649 3.36-4.26 5.14-.347 1.06-.367 1.96-.245 2.68h-1.671c-.469 0-.856.38-.856.84 0 .46.387.84.856.84h15.288c.469 0 .856-.38.856-.84 0-.48-.387-.84-.856-.84zM25.402 34.838c-.305-.9-.244-1.62-.122-2.14h8.438c.143.52.184 1.24-.122 2.14-.53 1.54-1.896 3.1-4.098 4.64-2.2-1.54-3.586-3.1-4.096-4.64h0zm0 11.322c.53-1.54 1.896-3.1 4.098-4.64 2.202 1.52 3.588 3.08 4.098 4.64.305.9.244 1.62.122 2.14h-8.438c-.144-.5-.185-1.24.12-2.14h0z",
  transform: "translate(-157 -196) translate(0 96) translate(157 102)"
})))));

var SvgIconHourglass = function SvgIconHourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-hourglass.b7cc86b7.svg";
export { ForwardRef as ReactComponent };